import { toast } from "react-toastify";
import { genericCoworkerCompanionAPICall } from "../../connexionApi/connexionApi";
import { ReservationsResponse } from "./ReservationsTypes";

const getReservations = (
  token: string,
  idSpace: number,
  startDate: number,
  endDate: number
) => {
  const globalStartDate = startDate - 28_800
  const globalEndDate = endDate
  const ENDPOINT_RESERVATIONS = `spaces/${idSpace}/reservation?startDate=${globalStartDate}&endDate=${globalEndDate}`;

  const reservations =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    ENDPOINT_RESERVATIONS,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as ReservationsResponse)
    .then((reservationResponse: ReservationsResponse) =>
      reservationResponse.map((reservation) => reservation)
    );

  // void toast.promise(reservations,
  //   {
  //     pending: 'Searching Reservations',
  //     error: 'Error please contact support 🤯'
  //   });


  return reservations;
};

const createReservation = async (token: string, idSpace: number, date: number) => {
  const ENDPOINT_RESERVATIONS = `spaces/${idSpace}/reservation`;
  const BODY = JSON.stringify({ "date": date / 1000 });

  const reservationsResult = genericCoworkerCompanionAPICall(
    token,
    "POST",
    ENDPOINT_RESERVATIONS,
    BODY
  )

  const reservationResponse = await toast.promise(
    reservationsResult,
    {
      success: 'Reservation created',
      pending: 'Creating Reservation',
      error: 'Contact support',
    });
  return reservationResponse;

};

const deleteReservation = async (token: string, idSpace: number, date: number) => {
  const ENDPOINT_RESERVATIONS = `spaces/${idSpace}?date=${date / 1000}`;
  //const BODY = JSON.stringify({ "date": date / 1000 });

  const reservationsResult =  genericCoworkerCompanionAPICall(
    token,
    "DELETE",
    ENDPOINT_RESERVATIONS,
    ""
  )

  const reservationResponse = await toast.promise(
    reservationsResult,
    {
      success: 'Reservation deleted',
      pending: 'Deleting Reservation',
      error: 'Contact support',
    });
  return reservationResponse;

};

const deleteUserReservation = async (token: string, idSpace: number, userId: number, date: number) => {
  const ENDPOINT_RESERVATIONS = `spaces/${idSpace}/reservation?userId=${userId}&date=${date / 1000}`;
  //const BODY = JSON.stringify({ "date": date / 1000 });

  const reservationsResult =  genericCoworkerCompanionAPICall(
    token,
    "DELETE",
    ENDPOINT_RESERVATIONS,
    ""
  )

  const reservationResponse = await toast.promise(
    reservationsResult,
    {
      success: 'Reservation deleted',
      pending: 'Deleting Reservation',
      error: 'Contact support',
    });
  return reservationResponse;

};

export { getReservations, createReservation, deleteReservation, deleteUserReservation };
